define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.MDppRepStatusDomain = void 0;
    class MDppRepStatusDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: MDppRepStatusDomain.Both, value: "Both" },
                    { key: MDppRepStatusDomain.Seeding, value: "Seeding" },
                    { key: MDppRepStatusDomain.Flowering, value: "Flowering" },
                    { key: MDppRepStatusDomain.None, value: "None" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[MDppRepStatusDomain.Both] = 0;
                this.KeyIndex[MDppRepStatusDomain.Seeding] = 1;
                this.KeyIndex[MDppRepStatusDomain.Flowering] = 2;
                this.KeyIndex[MDppRepStatusDomain.None] = 3;
                this.ValueIndex = {};
                this.ValueIndex["Both"] = 0;
                this.ValueIndex["Seeding"] = 1;
                this.ValueIndex["Flowering"] = 2;
                this.ValueIndex["None"] = 3;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.MDppRepStatusDomain = MDppRepStatusDomain;
    Object.defineProperty(MDppRepStatusDomain, "Both", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 4
    });
    Object.defineProperty(MDppRepStatusDomain, "Seeding", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 3
    });
    Object.defineProperty(MDppRepStatusDomain, "Flowering", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 2
    });
    Object.defineProperty(MDppRepStatusDomain, "None", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 1
    });
    Object.defineProperty(MDppRepStatusDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
